import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { ActiveRecord } from '../../models/record';
import { ResetStore, SetActiveRecord, SetActiveTab } from './user-list.actions';
import { patch } from '@ngxs/store/operators';

export type UserListStateModel = {
  activeRecord?: ActiveRecord;
  activeTab: number;
};

export const initialState: UserListStateModel = {
  activeRecord: undefined,
  activeTab: 0,
};

@State<UserListStateModel>({
  name: 'userList',
  defaults: initialState,
})
@Injectable()
export class UserListState {
  @Selector()
  static activeRecord(state: UserListStateModel): ActiveRecord | undefined {
    return state.activeRecord;
  }

  @Selector()
  static activeTab(state: UserListStateModel): number {
    return state.activeTab;
  }

  @Action(SetActiveRecord)
  setActiveRecord(context: StateContext<UserListStateModel>, { record }: SetActiveRecord) {
    context.setState(
      patch({
        activeRecord: record,
      })
    );
  }

  @Action(SetActiveTab)
  setActiveTab(context: StateContext<UserListStateModel>, { index }: SetActiveTab) {
    context.setState(
      patch({
        activeTab: index,
      })
    );
  }

  @Action(ResetStore)
  resetStore(context: StateContext<UserListStateModel>) {
    context.setState(initialState);
  }
}
